import { instance } from '../instance'

export const refresh = async (refresh_token) =>
  instance.put(
    '/v3/auth/token',
    { token: refresh_token },
    { skipAuthWait: true, skipAuth: true },
  )
